import { cn } from '#app/utils/misc'

export interface VerifiedBadgeProps {
	className?: string
	size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
	sm: 'h-4 w-4',
	md: 'h-5 w-5',
	lg: 'h-6 w-6',
}

export function VerifiedBadge({
	className,
	size = 'md',
}: VerifiedBadgeProps) {
	return (
		<svg
			className={cn('text-primary', sizeClasses[size], className)}
			viewBox="0 0 24 24"
			fill="currentColor"
			aria-label="Verified"
		>
			<path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
		</svg>
	)
}
